import React from 'react';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { container } from '@Container';
import { TYPES } from '@Types';
import { BookAction } from '@Redux/actions/publication/BookAction';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { bookPresenter } from '@Selectors/publication/book/make/book.presenter';
import BookSectionNewComponent from '@Components/publication/book-section-new/book-section-new.component';
import BookSectionsComponent from '@Components/publication/book-sections/book-sections.component';
import { DragDropContext } from '@hello-pangea/dnd';
import BookActionComponent from '@Components/publication/book-action/book-action.component';
import BookCloneComponent from '@Components/publication/book-clone/book-clone.component';
import BookDeleteComponent from '@Components/publication/book-delete/book-delete.component';
import BookEditComponent from '@Components/publication/book-edit/book-edit.component';
import BookBuildComponent from '@Components/publication/book-build/book-build.component';
import { FormattedMessage } from 'react-intl';
import { BookActionState } from '@Stores/publication/book.state';
import { defaultMessages } from '@I18n/default';

const PublicationBookPageMake: React.FC<Props> = ({
                                                    book,
                                                    actions,
                                                    load,
                                                    onDragEnd
                                                  }) => {
  const params = useParams();

  React.useEffect(() => {
    load(params.book_id!);
  }, []);

  const currentLocale = document.documentElement.lang;

  let content = (<div className='book'>
    <h2 className='text-center'><FormattedMessage {...defaultMessages.publicationBookShowTitle} /><br /><em>{book.name}</em></h2>
    <BookSectionNewComponent />
    <section className=' mb-2'>
      <div className='army_list_units_overview ui-sortable ms-3 mb-2'>
        <DragDropContext onDragEnd={onDragEnd}>
          <BookSectionsComponent sections={book.sections} />
        </DragDropContext>
      </div>
    </section>
  </div>);

  if (actions.requestClone) content = <BookCloneComponent/>;
  if (actions.requestDelete) content = <BookDeleteComponent/>;
  if (actions.requestEdit) content = <BookEditComponent/>;
  if (actions.requestBuild) content = <BookBuildComponent/>;

  return <>
    <BookActionComponent />

    <Breadcrumb tag='nav'>
      <BreadcrumbItem tag='a' href={`/${currentLocale}/builder/army_lists`}><i
        className='fa-solid fa-house'></i></BreadcrumbItem>
      <BreadcrumbItem tag='a' href={`/${currentLocale}/publication/books`}>My Books</BreadcrumbItem>
      <BreadcrumbItem tag='span' active>{book.name}</BreadcrumbItem>
    </Breadcrumb>

    {content}
  </>;
};

const mapStateToProps = (state: AppState) => ({
  book: bookPresenter(state),
  actions: {
    requestClone: BookActionState.Clone === state.book.action,
    requestDelete: BookActionState.Delete === state.book.action,
    requestEdit: BookActionState.Edit === state.book.action,
    requestBuild: BookActionState.Build === state.book.action,
  },
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<BookAction>(TYPES.Actions.Publication.BookAction);
  return {
    load: (id: string) => dispatch(action.fetchData({ entityId: id })),
    onDragEnd: (result: any) => dispatch(action.moveSection(
      result.draggableId,
      result.source.index,
      result.destination.index
    )),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicationBookPageMake);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
